import { useContext } from "react";

import SearchIcon from "~/icons/SearchIcon";
import ThemeContext from "~/contexts/ThemeContext";

import styles from "./SearchInput.module.css";

type SearchInputProps = {
  placeholder?: string;
  value: string;
  setValue: (value: string) => void;
};

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = "Search...",
  value,
  setValue,
}) => {
  const { template } = useContext(ThemeContext);

  // Styles
  const inputStyles = {
    backgroundColor: template.global.input.backgroundColour,
    borderColor: template.global.input.borderColour,
    color: template.global.input.fontColour,
    "--focus-search-select-background-colour":
      template.global.input.focusBackgroundColour,
    "--focus-search-select-border-colour":
      template.global.input.focusBorderColour,
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.searchIconWrapper}>
        <SearchIcon />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        className={styles.input}
        style={inputStyles}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
